module.exports = __webpack_public_path__ + "img/square-envelope.ca1e9311.svg";